export { default as FavoritesPicker } from './components/FavoritesPicker';
